import React, { useState } from 'react';
import styles from 'styles/shop/product.module.css';
import Player from 'components/shared/Player/Video';
import cx from 'classnames';
import { closeIcon, navDownIcon, navUpIcon, vidIcon } from 'components/shared/Icons/Product';
import { useAssets } from 'components/products/hooks';
import { useIsDesktop } from 'contexts/profile';
import { Share } from 'components/products/Share';
import { useToggle } from 'hooks/common';
import { Clickable } from 'phoenix-components';
import ZoomableImage from 'components/products/ZoomableImage';
import PropTypes from 'prop-types';
import { useKeenSlider } from 'keen-slider/react';


export function ProductSlides({ zoomRef }) {
  let assets = useAssets();
  const isDesktop = useIsDesktop();
  const [open, setOpen] = useToggle(false);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [sliderRef, instanceRef] = useKeenSlider(
    {
      initial: 0,
      slideChanged(slider) {
        setCurrentSlide(slider.track.details.rel);
      },
      slides: {
        perView: 1,
      },
    },
  );

  const [thumbsSliderRef, thumbInstanceRef] = useKeenSlider(
    {
      slideChanged(slider) {
        setCurrentSlide(slider.track.details.rel);
        instanceRef.current.moveToIdx(slider.track.details.rel);
      },
      slides: {
        perView: isDesktop ? 4 : 5,
        spacing: 10,
      },
      vertical: isDesktop,
    },
  );

  if (open) {
    assets = assets.filter(x => x.type !== 'video');
  }

  return (
    <div
      className={cx(styles.relative, {
        [styles.viewBox]: isDesktop,
        [styles.mobileOpen]: open,
      })}
    >
      {open &&
        (<Clickable onClick={setOpen} className={styles.back}>
          <div>
            {closeIcon()}
          </div>
        </Clickable>)}
      {isDesktop && <div
        className={cx(styles.thumbs, {
          [styles.sink]: assets.length === 1
        })}
      >
        <div ref={thumbsSliderRef} className={'keen-slider h-[360px]'}>
          {assets.map((el, i) => (
            <div
              key={i}
              className={cx('keen-slider__slide', {
                [styles.slideActive]: i === currentSlide,
              })}
              onClick={() => {
                instanceRef.current.moveToIdx(i);
              }}
            >
              {el.type !== 'video' && (
                <img
                  className={styles.thumbPreview}
                  src={el.url}
                  alt={el.title}
                />
              )}
              {el.type === 'video' && (
                <>
                  <Player item={el} type={true}/>
                  <div className={styles.overlay}>
                    {vidIcon()}
                  </div>
                </>
              )}
            </div>
          ))}
        </div>
        {assets.length > 1 && (
          <div className={styles.navButtons}>
            <div
              className={cx(styles.cursor, {
                'opacity-50': currentSlide === 0,
              })}
              onClick={() => {
                thumbInstanceRef.current.prev();
              }}
            >
              {navUpIcon()}
            </div>
            <div
              className={cx(styles.cursor, {
                'opacity-50': currentSlide === assets.length - 4,
              })}
              onClick={() => {
                thumbInstanceRef.current.next();
              }}
            >
              {navDownIcon()}
            </div>
          </div>
        )}
      </div>}
      <Share/>
      <div
        className={cx('keen-slider', {
          'h-[400px]': !open,
          'h-[92%]': open,
        })}
        ref={sliderRef}
      >
        {assets.map((el, i) => (
          <div key={i} className={'keen-slider__slide'}>
            {el.type !== 'video' && (
              <>
                {isDesktop ? (
                  <ZoomableImage zoomRef={zoomRef} url={el.url}/>
                ) : (
                  <Clickable
                    onClick={() => {
                      setOpen();
                    }}
                  >
                    <img
                      className={styles.product}
                      src={el.url}
                      alt={el.title}
                    />
                  </Clickable>
                )}
              </>
            )}
            {el.type === 'video' && (
              <Player item={el}/>
            )}
          </div>
        ))}
      </div>
      {!isDesktop && <div
        className={cx({
          [styles.sink]: assets.length === 1
        })}
      >
        <div ref={thumbsSliderRef} className={'keen-slider'}>
          {assets.map((el, i) => (
            <div
              key={i}
              className={cx('keen-slider__slide cursor-pointer', {
                [styles.slideActive]: i === currentSlide,
              })}
              onClick={() => {
                instanceRef.current.moveToIdx(i);
              }}
            >
              {el.type !== 'video' && (
                <img
                  className={styles.productPreview}
                  src={el.url}
                  alt={el.title}
                />
              )}
              {el.type === 'video' && (
                <>
                  <Player item={el} type={true}/>
                  <div className={styles.overlay}>
                    {vidIcon()}
                  </div>
                </>
              )}
            </div>
          ))}
        </div>
      </div>}
    </div>
  );
}

ProductSlides.propTypes = {
  zoomRef: PropTypes.object.isRequired,
};
